/*!
* name ZJX 作品集
* Copyright 2018-2019
*/
<template>
  <div class>
    <publicNav></publicNav>
    <div class="submit_box" v-if="isHide == 1">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label>
          <el-select v-model="formInline.region1" placeholder="请选择">
            <el-option label="学生作品" value="student"></el-option>
            <el-option label="本人作品" value="myself"></el-option>
            <el-option label="其他老师作品" value="teacher"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label>
          <el-select v-model="formInline.region2" placeholder="请选择">
            <el-option label="未分享" value="0"></el-option>
            <el-option label="已分享" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <template>
      <el-table
        :data="tableData"
        style="width: 100%"
        :default-sort="{prop: 'date', order: 'descending'}">
        <el-table-column prop="title" label="作品标题" width="126"></el-table-column>
        <el-table-column prop="author.name" label="创作者" width="140">
          <template slot-scope="scope">
            <div v-if="scope.row.author.type_id == 1">
              <!--<img class="type_el" src="../../assets/images/laoshi.png" alt="">-->
              <span>{{scope.row.author.name}} 老师</span>
            </div>
            <div v-else>
              <!--<img class="type_el" src="../../assets/images/xuesheng.png" alt="">-->
              <span>{{scope.row.author.name}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="type_name" label="作品类型" width="94"></el-table-column>
        <el-table-column prop="is_shared" label="分享状态" width="90">
          <template slot-scope="scope">
            <span v-if="scope.row.is_shared == 0">未分享</span>
            <span v-else>已分享</span>
          </template>
        </el-table-column>
        <el-table-column prop="score_num" label="评分" width="66">
          <template slot-scope="scope">
            <span>{{!scope.row.score_num ? 0 : scope.row.score_num}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="thumb_up_num" label="赞" width="44">
          <template slot-scope="scope">
            <span>{{!scope.row.thumb_up_num ? 0 : scope.row.thumb_up_num}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="日期" width="106">
          <template slot-scope="scope">
            <span>{{scope.row.created_at ? scope.row.created_at.split(' ')[0] : ''}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operator.name" label="发送老师" width="100">
          <template slot-scope="scope">
            <span>{{scope.row.operator==null?'乐画网':scope.row.operator.name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="btn" label width="100">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="pageSize"
        :total="totalData"
        @current-change="pageNumberChange"
      ></el-pagination>
    </template>
  </div>
</template>

<script>
import publicNav from '@/components/publicnav' //引入公共页签
import cacheUtils from '@/common/cacheUtils' //调用缓存
import apiInterface from '@/api/index' //接口
export default {
  data () {
    return {
      //查询
      formInline: {
        region1: '',
        region2: ''
      },
      //表格数据
      tableData: [],
      totalData: 0, //数据总数
      pageSize: 10, //每页条数
      isHide: cacheUtils.sessionStorage('status').get('zjx')
    }
  },
  computed: {},
  components: {
    publicNav
  },
  mounted () {},
  methods: {
    //查询
    onSubmit () {
      console.log('submit!')
      console.log(this.formInline.region1)
      console.log(this.formInline.region2)
      this.getSampleReelsDataList()
    },
    formatter (row, column) {
      return row.address
    },
    handleEdit (index, row) {
      this.$router.push({
        path: '/sharingcenterdetails',
        query: {
          id: row.id,
          source: 'zpj'
        }
      })
    },
    // 分页页码改变
    pageNumberChange (pageNumber) {
      this.getSampleReelsDataList(pageNumber)
    },
    //获取作品集列表
    async getSampleReelsDataList (pages = 1) {
      let data = {
        page: pages,
      }
      if (this.formInline.region2) {
        data.is_shared = this.formInline.region2
      }
      if (this.formInline.region1) {
        data.author_type = this.formInline.region1
      }
      try {
        let pdata = await this.$xhr.get(
          cacheUtils.sessionStorage('status').get('zjx') == '1'
            ? apiInterface.works
            : apiInterface.myStudentsWorks,
          {
            params: data
          }
        )
        this.tableData = pdata.data
        this.totalData = pdata.meta.pagination.total
      } catch (error) {
        this.$message.error(error.message)
      }
    }
  },
  created () {
    console.log(apiInterface.myStudentsWorks)
    this.getSampleReelsDataList()
    console.log(cacheUtils.sessionStorage('status').get('zjx'))
  },
  watch: {},
  props: {}
}
</script>

<style lang="scss">
.el-table__header-wrapper {
  margin-top: 10px;
}

.el-table thead tr th {
  background: #eeeeee;
}

.submit_box {
  text-align: center;
  padding-top: 20px;
}

.type_el {
  float: left;
  width: 20px;
  height: 20px;
}
</style>

